export default "__VITE_ASSET__yYBZkr9E__"